import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function deleteStudente(uname, token, id) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "deleteStudente.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        try {
          const result = JSON.parse(body.toString());
          resolve(result);
        } catch (error) {
          console.error("Errore parsing JSON:", error);
          resolve({ result: "KO", error: "Errore parsing risposta server" });
        }
      });

      res.on("error", function(error) {
        console.error(error);
        reject(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id: id,
    });

    req.write(postData);

    req.end();
  });
}
